// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"56":"b420d24a","284":"f8ebbc40","534":"6ea702c5","675":"1c0ebe93","793":"a67decea"}[chunkId] + ".css";
};